// Smooth measured points without crossing a local maximum or minimum.
// Call once per contiguous segment; an unknown day must never enter this path.
export function smoothMetricPath(points) {
  if (!points.length) return '';
  if (points.length === 1) return `M ${points[0][0]} ${points[0][1]}`;
  const slopes = points.slice(1).map(([x, y], i) => (y - points[i][1]) / (x - points[i][0]));
  const tangent = points.map((_, i) => {
    if (i === 0) return slopes[0];
    if (i === points.length - 1) return slopes[slopes.length - 1];
    const before = slopes[i - 1], after = slopes[i];
    return before * after > 0 ? 2 * before * after / (before + after) : 0;
  });
  return points.slice(1).reduce((path, [x, y], i) => {
    const [prevX, prevY] = points[i];
    const third = (x - prevX) / 3;
    return `${path} C ${prevX + third} ${prevY + tangent[i] * third}, ${x - third} ${y - tangent[i + 1] * third}, ${x} ${y}`;
  }, `M ${points[0][0]} ${points[0][1]}`);
}
